import { createAsyncThunk } from "@reduxjs/toolkit";
import OrderApiService from "../apiServices/OrderApiService";
import type {
  CreateOrderPayload,
  GetOrdersPayload,
  RespondToOrderPayload,
} from "../../interfaces/OrderObject";

// create / respond let errors PROPAGATE (no rejectWithValue) so the calling
// component's `.unwrap()` surfaces the real message for a toast — same rationale
// as the businessSearch thunk.
export const createOrder = createAsyncThunk(
  "orders/createOrder",
  async (payload: CreateOrderPayload) => {
    return await OrderApiService.createOrder(payload);
  }
);

export const respondToOrder = createAsyncThunk(
  "orders/respondToOrder",
  async (payload: RespondToOrderPayload) => {
    return await OrderApiService.respondToOrder(payload);
  }
);

// get loads into the slice's error/loading maps, so it uses rejectWithValue with
// a clean message (the list view reads errorMap to render its error state).
export const fetchOrdersByBusinessId = createAsyncThunk(
  "orders/fetchOrdersByBusinessId",
  async (payload: GetOrdersPayload, { rejectWithValue }) => {
    try {
      return await OrderApiService.getOrdersByBusinessId(payload);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);
